// @ts-nocheck

import memoize from 'memoize-state';
import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { __ } from '../../../i18n/l10n';
import GridsInfoBasket from '../components/basket/GridsInfoBasket';
import Selection from '../states/selection';

const legacySelector = memoize((state) => {
  const { selections, isSystem } = state.grids.basket;
  let label = null;

  if (!isSystem) {
    const selection = selections[0];
    if (selection && Selection.hasEnoughChecks(selection)) {
      const countDouble = Selection.getCountDoubles(selection);
      const countTriple = Selection.getCountTriples(selection);
      if (countDouble > 0 || countTriple > 0) {
        label = __('Your grid has %1$s double', countDouble, 'Your grid has %1$s doubles');
        label += ' ' + __('and %1$s triple', countTriple, 'and %1$s triples');
      }
    }
  }

  return {
    label,
  };
});

type GridsInfoBasketContainerProps = {
  className?: string;
};

const GridsInfoBasketContainer = (ownProps: GridsInfoBasketContainerProps) => {
  const selectedProps = useSelector(legacySelector);

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <GridsInfoBasket {...enhancedProps} />;
};

export default GridsInfoBasketContainer;
